export default {
  /**
   * Devuelve el estado local de favorito para un ítem.
   *
   * @returns {boolean | null}
   *   - boolean → valor local conocido (el usuario interactuó con este ítem)
   *   - null    → sin datos locales; el consumidor debe usar el valor de la API
   */
  isFavorite: (state) => (contentType, slug) => {
    const key = `${contentType}:${slug}`
    return Object.prototype.hasOwnProperty.call(state.favorites, key)
      ? state.favorites[key]
      : null
  },
}
